import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from "react-router-dom";
import { Report } from '@mui/icons-material';
import { Button, Snackbar } from '@mui/joy';
import { useAuth } from '../context/authContext';

import AppDataContainer from '../components/AppDataContainer';
import PrivateNavigationHeader from '../components/PrivateNavigationHeader';
import SideMenu from '../components/SideMenu';

import revault_logo from '../resources/logo.svg'

const networking = require('../Networking/API');

function AppComponent() {
    const { subscription } = useAuth();

    const [parameters, setParameters] = useSearchParams();
    const [activeComponent, setActiveComponent] = useState(0);
    const [currentSubscription, setCurrentSubscription] = useState(subscription);
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    let navigate = useNavigate();

    const currentApp = JSON.parse(localStorage.getItem("currentApp")!);

    const sessionId = parameters.get('session_id');
    const plan = parameters.get('plan');

    if (sessionId) {
        networking.customer(sessionId).then((data: any) => {
            networking.updateState(currentSubscription!.id, sessionId, data.str_customer_id, data.str_subscription_id, plan).then((data: any) => {
                getNewData();
            }).catch((error: Error) => {
                setShowError(true);
                setError(error.message);
            });

        }).catch((error: Error) => {
            setShowError(true);
            setError(error.message);
        });

        parameters.delete('session_id')
        setParameters(parameters)
    }

    const getNewData = () => {
        networking.authenticateSubscription(currentSubscription!.id).then((sub: any) => {
            setCurrentSubscription(sub);
            localStorage.setItem("savedState", JSON.stringify(sub));
            setShowSuccess(true);

        }).catch((error: Error) => {
            setShowError(true);
            setError(error.message);
        });
    }

    const itemTapped = (index: any) => {
        loadComponent(index);
    }

    function loadComponent(id: any) {
        console.log('Component ID: ' + id);

        if (id === 11) {
            goBack();
        } else {
            setActiveComponent(id);
        }
    }

    const updateSubscription = (subscription: any) => {
        setCurrentSubscription(subscription);
    }

    function goBack() {
        localStorage.removeItem("currentApp");
        navigate('/apps-list');
    }

    return (
        <div>
            {showError &&
                <Snackbar
                    variant="soft"
                    color="danger"
                    open={showError}
                    onClose={() => setShowError(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowError(false)}
                            size="sm"
                            variant="soft"
                            color="danger"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    {error}
                </Snackbar>
            }
            {showSuccess &&
                <Snackbar
                    variant="soft"
                    color="success"
                    open={showSuccess}
                    onClose={() => setShowSuccess(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowSuccess(false)}
                            size="sm"
                            variant="soft"
                            color="success"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    Profile updated! 🚀
                </Snackbar>
            }
            <PrivateNavigationHeader
                subscription={currentSubscription}
                onSubscriptionUpdate={updateSubscription} />
            <div className='container-fluid' style={{ height: 100 + '%' }}>
                <div className='row'>
                    <div className='col-auto p-0'>
                        <SideMenu
                            plan={currentSubscription!.plan}
                            app={currentApp}
                            handler={itemTapped} />
                    </div>
                    <div
                        className='col bg-cloudie p-4'>
                        {
                            activeComponent !== 11 &&
                            <div style={{
                                height: 100 + 'vh',
                                overflow: 'auto',
                                scrollbarWidth: 'none',
                            }}>
                                <AppDataContainer
                                    component={activeComponent}
                                    app={currentApp}
                                    subscription={currentSubscription}
                                    handler={itemTapped} />
                            </div>
                        }

                    </div>
                </div>
            </div>
        </div >
    );
}

export default AppComponent;